import { reactive } from 'vue';
import { safeLocalStorage } from '@/client/utils/SafeLocalStorage';
const defaults = {
    learner_mode: true,
    enable_sounds: true,
    magnify_cards: true,
    show_alerts: true,
    lang: 'en',
    hide_hand: false,
    hide_awards_and_milestones: false,
    show_milestone_details: true,
    show_award_details: true,
    hide_top_bar: false,
    small_cards: false,
    remove_background: false,
    hide_active_cards: false,
    hide_automated_cards: false,
    hide_event_cards: false,
    hide_tile_confirmation: false,
    hide_discount_on_cards: false,
    hide_animated_sidebar: false,
    symbol_overlay: false,
    animated_title: true,
    experimental_ui: false,
    debug_view: false,
    remember_create_game_settings: false,
};
export class PreferencesManager {
    static resetForTest() {
        this.INSTANCE = new PreferencesManager();
    }
    constructor() {
        // Reactive so components update when preferences change, without a page refresh.
        this._values = reactive({ ...defaults });
        for (const key of Object.keys(defaults)) {
            const value = safeLocalStorage.getItem(key);
            if (value) {
                this._set(key, value);
            }
        }
    }
    _set(key, val) {
        if (key === 'lang') {
            this._values.lang = String(val);
        }
        else {
            this._values[key] = typeof (val) === 'boolean' ? val : (val === '1');
        }
    }
    // Making this Readonly means that it's Typescript-impossible to
    // set preferences through the fields themselves.
    values() {
        return this._values;
    }
    set(name, val, setOnChange = false) {
        // Don't set values if nothing has changed.
        if (setOnChange && this._values[name] === val) {
            return;
        }
        this._set(name, val);
        if (name === 'lang') {
            safeLocalStorage.setItem(name, this._values.lang);
        }
        else {
            safeLocalStorage.setItem(name, val ? '1' : '0');
        }
    }
}
PreferencesManager.INSTANCE = new PreferencesManager();
export function getPreferences() {
    return PreferencesManager.INSTANCE.values();
}
